<template>
  <div :class="`attachment-list ${isLoading ? 'busy' : ''}`">
    <div v-if="readonly && !hasAttachments">
      <h4>{{$t('No files uploaded')}}</h4>
    </div>
    <div v-if="compact && hasAttachments" class="pad-20">
      <template v-for="(attachment, index) in attachments">
        <a href="javascript: void 0" @click="openPreview(attachment)">
          <span class="fileicon fileicon-sm float-left mright-10" :data-type="attachment.extension" :style="{background: getIconColor(attachment)}"></span>{{ attachment.filename }}
        </a>
        &nbsp;
        <a :href="getDownloadUrl(attachment)" v-if="allowDownload"><i class="fas fa-download"></i></a>
        &nbsp;
        <a href="javascript: void 0" @click="remove(attachment.hash)" v-if="allowDeleting" style="color: #e74c3c">
          <i class="fa fa-trash"></i>
        </a>
      </template>
    </div>
    <table class="datatable table table-striped primary dataTable no-footer" v-if="hasAttachments && !compact">
      <thead>
        <tr>
          <th>{{ $t('File.name') }}</th>
          <th v-if="showHash">{{ $t('File.hash') }}</th>
          <th v-if="!readonly"></th>
        </tr>
      </thead>
      <tbody>

        <tr v-for="(attachment, index) in attachments" class="clear">
          <td>
            <a href="javascript: void 0" @click="openPreview(attachment)">
              <span class="fileicon fileicon-sm float-left mright-10" :data-type="attachment.extension" :style="{background: getIconColor(attachment)}"></span>{{ attachment.filename }}
            </a>
            <a :href="getDownloadUrl(attachment)" v-if="allowDownload"><i class="fas fa-download"></i></a>
          </td>
          <td v-if="showHash">
            {{ attachment.hash | shortHash }}
          </td>
          <td class="a-r" v-if="allowDeleting">
            <button type="button" class="btn btn-xs btn-danger" v-on:click="remove(attachment.hash)">
              <i class="fa fa-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="pad-20" v-if="allowUploading">
      <attachment
        ref="attachment"
        :url="url"
        :max-filesize="maxFilesize"
        :max-files="maxFiles ? maxFiles - attachments.length : undefined"
        :accepted-files="acceptedFiles"
        :files="files"
        :upload-status="uploadStatus"
        :upload-message="uploadMessage"
        :upload-error="uploadError"
        :append-token="appendToken"
        :placeholder="placeholder"
        :file-names="fileNames"
        :error-message="errorMessage"
        :dropzone-height="dropzoneHeight"
        v-on:complete="handleUploadComplete"
        v-on:progress="handleUploadProgress"
        v-on:addfile="handleUploadAddFile"
        v-on:status="emitStatus"
      ></attachment>
    </div>
  </div>
</template>
<script>
var util = require('../util.js');

export default {
  name: 'attachments',
  props: {
    url: {
      type: String
    },
    maxFilesize: {
      type: Number,
      default: 500
    },
    maxFiles: {
      type: Number,
      default: 100
    },
    minFiles: {
      type: Number,
      default: 0
    },
    readonly: {
      type: Boolean,
      default: false
    },
    acceptedFiles: {
      type: [String, Array],
      default: ''
    },
    placeholder: {
      type: [String, Object]
    },
    fileNames: {
    },
    errorMessage: {
      type: [String, Object],
      default: null,
    },
    dropzoneHeight: {
      type: Number,
    },
    compact: {
      type: Boolean,
    },
    showHash: {
      type: Boolean,
    }
  },
  computed: {
    hasAttachments() {
      return this.attachments.length > 0;
    },
    allowDeleting() {
      return !this.readonly && !this.$root.restrictAttachmentDelete;
    },
    allowUploading() {
      return !this.readonly && !this.$root.restrictAttachmentAdd && (!this.maxFiles || this.attachments.length < this.maxFiles);
    },
    allowDownload() {
      return this.$root.restrictAttachmentDownload !== true;
    }
  },
  mounted() {
    this.listing(true);
  },
  filters: {
    shortHash(hash) {
      return hash.substr(0, 7);
    }
  },
  data: function() {
    return {
      attachments: [],
      files: [],
      uploadStatus: 'idle',
      uploadMessage: '',
      uploadError: '',
      appendToken: true,
      isLoading: 0,
    }
  },
  methods: {
    handleUploadComplete(fileuploader, file) {
      if (file && file.xhr && file.xhr.status >= 200 && file.xhr.status < 300) {
        this.listing();
      }

      for (var i = 0; i < this.files.length ; i++) {
        if (this.files[i].name == file.name) {
          this.files.splice(i, 1);
        }
      }

      if (this.files.length === 0) {
        this.uploadStatus = 'idle';
      }
    },
    handleUploadProgress(progress, file) {
      for (var i = 0; i < this.files.length ; i++) {
        if (this.files[i].name == file.name) {
          this.$refs.attachment.$forceUpdate();
          this.files[i].progress = progress;
          return;
        }
      }
    },
    handleUploadCancel(file) {
      for (var i = 0; i < this.files.length ; i++) {
        if (this.files[i].name == file.name) {
          this.files.splice(i, 1);
        }
      }

      if (this.files.length === 0) {
        this.uploadStatus = 'idle';
      }

      this.$forceUpdate();
      this.$refs.attachment.$forceUpdate();
    },
    handleUploadAddFile(fileuploader, file) {
      this.files.push(file);
      this.uploadStatus = 'sending';
    },
    listing(isInitialCall) {
      this.isLoading++;
      this.$http.get(this.url).then(
        function(res) {
          this.isLoading--;
          this.attachments = res.data.result;
          this.$emit('loaded', res.data.result, isInitialCall);
          this.$emit('valid',
            (this.attachments.length <= this.maxFiles || !this.maxFiles)
            &&
            (this.attachments.length >= this.minFiles || !this.minFiles)
          );
        }.bind(this),
        function(res) {
          this.isLoading--;
          this.$emit('error', this.$t('File.errorCouldNotLoad'));
        }.bind(this)
      );
    },
    remove(hash) {
      if (!confirm(this.$t('Action.removeAttachment'))) return;
      this.$http.delete(this.url + '/' + hash).then(
        function(res) {
          this.listing();
        }.bind(this),
        function(res) {
          this.$emit('error', this.$t('File.errorCouldNotDelete'));
        }.bind(this));
    },
    getIconColor(attachment) {
      return util.fileIconColor(attachment.extension);
    },
    emitStatus(status, file, message) {
      if (status === 'cancelled') {
        this.handleUploadCancel(file);
        return
      }

      this.$emit('status', status, file, message);
    },
    getDownloadUrl(attachment) {
      return this.url + '/' + attachment.hash + ':' + attachment.token + '/' + attachment.filename;
    },
    openPreview(attachment) {
      const url = this.getDownloadUrl(attachment);
      this.$parent.$parent.$parent.$parent.$parent.$parent.openPreviewDialog(url, attachment.filename, !this.$root.restrictAttachmentDownload);
    }
  }
};
</script>
<style scoped>
  .attachment-list {
    position: relative;
  }

  .attachment-list::after {
    content: '';
    opacity: 0;
  }

  .attachment-list.busy::after {
    content: ' ';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    color: rgba(127,127,127,.5);
    background: rgba(255,255,255,.5);
    opacity: 1;
    transition: opacity .3s ease-in-out;
    text-align: center;
  }
</style>
